import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { useIsSmallerThan } from 'src/hooks/useIsSmallerThan'
import CounterContainer from 'src/containers/CounterContainer/CounterContainer'
import CounterContainerShared
    from 'training-lane-booking-shared/containers/CounterContainerShared/CounterContainerShared'
import Logo from 'src/components/UI/Logo/Logo'
import BackToBookingButton from 'src/components/UI/BackToBookingButton/BackToBookingButton'
import { filterTypesByCapabilities, isLoggedIn, typesByBookingPage } from 'training-lane-booking-shared/utilities/functions'
import { roles, types } from 'training-lane-booking-shared/utilities/constants'
import headerClasses from './Header.module.scss'

const HeaderItemsWrapper = ({ isXSmall, children }) => (
    isXSmall ? (
        <div className="right-aligned-group">{children}</div>
    ) : (
        <>{children}</>
    )
)

const CounterWrapper = ({
    children,
    isSmall,
    isMedium,
    bookingPage,
    capabilities,
    roleId
}) =>
    isSmall ? (
        <>{children}</>
    ) : (
        <div
            className={classNames(
                'grid-wrapper-100',
                'align-right',
                `grid-wrapper-${
                    !capabilities.canPostPay &&
                    bookingPage.length &&
                    bookingPage === 'lanes'
                        ? 4
                        : isMedium && roles.vip.id === roleId
                            ? 6
                            : roles.vip.id === roleId ? 5 : 8
                } col-${
                    !capabilities.canPostPay &&
                    bookingPage.length &&
                    bookingPage === 'ref-and-sauna' &&
                    isMedium
                        ? 6
                        : 4
                }`
            )}>
            {children}
        </div>
    )

const Header = ({
    credits,
    landingPage,
    pageTitle,
    pathName,
    bookingPage,
    isSmall,
    isXSmall
}) => {
    const isMedium = useIsSmallerThan(1280)
    // noinspection JSUnresolvedVariable
    const roleId = useSelector(state => state.firebase.profile?.token?.claims?.roleId)
    // noinspection JSUnresolvedVariable
    const capabilities = useSelector(state => state.auth.capabilities)
    const isStaffOrAdmin = [roles.staff.id, roles.admin.id].includes(roleId)
    const counterTypes = filterTypesByCapabilities(
        capabilities.canPostPay ? typesByBookingPage('lanes', types) : types,
        capabilities,
        true
    )
    const counterTitleCount = new Set(
        counterTypes.map(type => type.description.categoryShort)
    ).size
    const filteredTypesLength = counterTypes.length + (counterTitleCount * 2)

    const logoProps = {
        isStaffOrAdmin,
        bookingPage,
        landingPage,
        isXSmall,
        isMedium
    }

    const counterWrapperProps = { isSmall, isMedium, bookingPage, capabilities, roleId }

    const loggedIn = useSelector(state => isLoggedIn(state))

    const showCounter =
        loggedIn && pathName.indexOf('/booking') !== -1 && !isStaffOrAdmin

    const memberOnBookingSubPage = bookingPage.length && !capabilities.canPostPay

    return (
        <section className={headerClasses.header}>
            <div className="grid-wrapper">
                {isXSmall && memberOnBookingSubPage ? (
                    <BackToBookingButton
                        isXSmall
                        buttonStyles={{
                            marginBottom: -27,
                            marginTop: 7,
                            fontSize: '1.2em'
                    }} />
                ) : null}
                <HeaderItemsWrapper isXSmall={isXSmall}>
                    {!isXSmall ? (
                        <Logo {...logoProps} />
                    ) : null}
                    {

                        <>
                            {/*For now we decided the red circled back button is not needed on web*/}
                            {/*{*/}
                            {/*    !isXSmall && memberOnBookingSubPage ? (*/}
                            {/*        <div className="col-1">*/}
                            {/*            <BackToBookingButton*/}
                            {/*                buttonStyles={{*/}
                            {/*                    marginTop: isSmall ? 8 : 12,*/}
                            {/*                    fontSize: '1.8rem'*/}
                            {/*                }}/>*/}
                            {/*        </div>*/}
                            {/*    ) : null*/}
                            {/*}*/}
                            {
                                isMedium && bookingPage === 'lanes' ? <div className="col-3"></div> : null
                            }
                            {
                                !isXSmall && (
                                    <div
                                        className={classNames(
                                            `col-${!showCounter
                                                ? 4
                                                : Math.max(1, 12 - filteredTypesLength - (roles.vip.id === roleId ? 3 : 0))}`,
                                            headerClasses.headerMiddleText
                                        )}>
                                        {pageTitle}
                                    </div>
                                )
                            }
                            {
                                showCounter ? (
                                    <CounterWrapper {...counterWrapperProps}>
                                        <CounterContainerShared
                                            bookingPage={capabilities.canPostPay ? 'lanes' : bookingPage}
                                            credits={credits}
                                            capabilities={capabilities}
                                            CounterContainer={CounterContainer}
                                        />
                                    </CounterWrapper>
                                ) : null
                            }
                        </>
                    }
                </HeaderItemsWrapper>
            </div>
        </section>
    )
}

export default Header
